import { Button, Card } from "react-bootstrap"
import { Link } from "react-router-dom"
import { PropertyAmenityType } from "../../../Types/propertyAmenityTypes"
import { useState } from "react"
import canAccess from "../../../services/accessService/accessService"
import PropertyTitleText from "../../PropertyEntry/PropertyTitleText"
import useAmenityRefs from "../../../Hooks/UseAmenities/useAmenityRefsHook"
import { BoxArrowUpRight } from "react-bootstrap-icons"

export default function PropertyAmenityEntry(props: {
    propertyAmenityData: PropertyAmenityType,
    fullView?: boolean,
    showActions?: boolean,
}) {

    const {
        propertyAmenityData,
        fullView: initialFullView = false,
        showActions = true,
    } = props

    const [fullView, setFullView] = useState(initialFullView)
    const amenityRefs = useAmenityRefs()

    const {
        _id,
        propertyId,
        amenityId,
        overrides,
    } = propertyAmenityData

    const amenityData = amenityRefs[amenityId]
    const amenityName = amenityData?.title || amenityId

    return (
        <Card className="mb-3">
            <Card.Body>
                <Card.Title>
                    {amenityName}
                    {canAccess('routes', 'amenity') && amenityData?._id && (
                        <Link to={`/amenity/${amenityData._id}`} className="ms-2 small">
                            <BoxArrowUpRight size={16} viewBox={'0 0 20 20'} />
                        </Link>
                    )}
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    <PropertyTitleText propertyId={propertyId} shortName={true} />
                </Card.Subtitle>

                {fullView && (
                    <>
                        <hr />
                        <Card.Text className="mb-1 small">
                            <strong>Property ID:</strong> {propertyId}
                        </Card.Text>
                        <Card.Text className="mb-1 small">
                            <strong>Amenity ID:</strong> {amenityId}
                        </Card.Text>
                        {overrides && Object.keys(overrides).length > 0 && (
                            <Card.Text className="mb-1 small">
                                <strong>Overrides:</strong>
                                <pre className="mt-1">{JSON.stringify(overrides, null, 2)}</pre>
                            </Card.Text>
                        )}
                    </>
                )}

            </Card.Body>

            {showActions && (
                <Card.Footer>
                    {!initialFullView && canAccess('routes', 'property-amenity') && (
                        <Link className="btn btn-primary btn-sm me-2 mb-2" to={`/property-amenity/${_id}`}>
                            View
                        </Link>
                    )}
                    {canAccess('routes', 'edit-property-amenity') && (
                        <Link className="btn btn-secondary btn-sm me-2 mb-2" to={`/edit-property-amenity/${_id}`}>
                            Edit
                        </Link>
                    )}
                    {canAccess('routes', 'delete-property-amenity') && (
                        <Link className="btn btn-danger btn-sm me-2 mb-2" to={`/delete-property-amenity/${_id}`}>
                            Delete
                        </Link>
                    )}
                    {!initialFullView && (
                        <Button
                            className="me-2 mb-2"
                            variant="secondary"
                            size="sm"
                            onClick={() => setFullView(!fullView)}
                        >
                            {fullView ? 'Hide Details' : 'Show Details'}
                        </Button>
                    )}
                </Card.Footer>
            )}
        </Card>
    )
}
